import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07e5597d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HotSearch abs" }
const _hoisted_2 = {
  key: 0,
  class: "HotSearch-block"
}
const _hoisted_3 = { class: "HotSearch-title" }
const _hoisted_4 = { class: "HotSearch-block-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "HotSearch-title",
  style: {"margin-top":"10px"}
}
const _hoisted_7 = { class: "HotSearch-title" }
const _hoisted_8 = {
  key: 0,
  class: "HotSearch-title-icon"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "HotSearch-block-list" }
const _hoisted_11 = ["onClick"]

import { onMounted, reactive, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { brandSearchHistory } from '@/apis/brand'
import { useRequest } from '@/util/useLoading'
import { useStore } from 'vuex'
import { useSite2Station } from '@/store'
import { res } from '@/apis/login'
import { Site } from '@/common/const'
interface HostListItem {
  productCategoryFrontendId: string;
  keywordList: string[];
  cateNameZh: string;
  cateNameJp: string;
  cateIcon?: string;
}


export default /*#__PURE__*/_defineComponent({
  emits: ['selected', 'handleSearch'],
  setup(__props, { emit: emits }) {

const store = useStore()
const site = useSite2Station()
const buss = store.state.bussiness
const token = computed(() => store.getters.token)

onMounted(() => {
  if (token.value) {
    getHistoryList({
      stationCode: site
    })
  }

  // getHotList({
  //   stationCode: site
  // })
})



const data: any = reactive({
  // 历史关键词列表
  historyList: [],
  // 热搜关键词列表
  hotList: []
})

// 获取历史搜索关键词
const [historyLoading, getHistoryList] = useRequest<res, {stationCode: Site}>(
  brandSearchHistory,
  {
    onSuccess (res) {
      if (res.code === '0') {
        // 历史搜索最多只展示10条
        data.historyList = (res.data || []).slice(0, 10)
      }
    }
  }
)

// // 获取热搜关键词
// const [hotLoading, getHotList] = useRequest<
//   res<HostListItem[]>,
//   { stationCode: Site }
// >(getHotSearch, {
//   onSuccess (res) {
//     if (res.code === '0') {
//       // 每个分类下，最多只展示10个关键词
//       data.hotList = res?.data
//         ?.map?.((category) => {
//           const keywordList = category.keywordList.slice(0, 10)
//           return {
//             ...category,
//             keywordList
//           }
//         })
//         .reverse()
//     }
//   }
// })

// 选中关键词
const selected = (keyword: string) => {
  console.log(keyword)
  emits('selected', keyword)
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(token))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("搜索历史")), 1),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).historyList, (keyword, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: index,
                onClick: ($event: any) => (selected(keyword))
              }, _toDisplayString(keyword), 9, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("热门推荐词")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).hotList, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "HotSearch-block",
        key: item.productCategoryFrontendId
      }, [
        _createElementVNode("div", _hoisted_7, [
          (item.cateIcon)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  referrerPolicy: "no-referrer",
                  class: "wrap",
                  src: item.cateIcon,
                  alt: ""
                }, null, 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString({
          [_unref(Site).JP]: item.cateNameJp,
          [_unref(Site).KR]: item.cateNameKr,
          [_unref(Site).UK]: item.cateNameKr,
        }[_unref(site)]), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keywordList, (keyword) => {
            return (_openBlock(), _createElementBlock("span", {
              key: keyword,
              onClick: ($event: any) => (selected(keyword))
            }, _toDisplayString(keyword), 9, _hoisted_11))
          }), 128))
        ])
      ]))
    }), 128))
  ], 512)), [
    [_directive_loading, _unref(historyLoading)]
  ])
}
}

})